import { Link } from 'react-scroll'; 
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 import { faListUl } from '@fortawesome/free-solid-svg-icons';
export default function Header(){
    const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  

  
    return <>
     
    <div className="header-container">
       
<div className='header'>
<img src={require('../images/pocket png-02.png')} alt='logo'/>
<div>
<ul className='header-list'>
<Link to="home" 
            spy={true} 
            smooth={true} 
            duration={500}><li>الرئيسية</li></Link>
<Link to="about-us" 
             offset={-50}  // Adjust for fixed headers
             smooth={true}
            ><li>من نحن</li></Link>
<Link to="service" 
            offset={-50}  // Adjust for fixed headers
            smooth={true}
            ><li>خدماتنا</li></Link>
<Link to="reviews" 
            offset={-50}  // Adjust for fixed headers
            smooth={true}
            ><li>الاراء والتقيمات</li></Link>
<Link to="footer" 
            offset={-50}  // Adjust for fixed headers
            smooth={true}
            ><li>تواصل معنا</li></Link>
           
</ul>

</div>
<div className='list-icon-class'>
<FontAwesomeIcon icon={faListUl} className='list-icon' onClick={toggleVisibility}/>
{/* <FontAwesomeIcon icon={faListUl} /> */}
</div>
<div className='responsive-list' style={{visibility: isVisible ? "visible" : "hidden",
opacity:isVisible ? 1 : 0,
          transform: `translateY(${isVisible ? '0' : '10px'})`,
          transition: 'all 0.3s ease-in-out',
          }}>
<ul>
<Link to="home" 
            spy={true} 
            smooth={true} 
            duration={500}
           ><li  onClick={toggleVisibility}>الرئيسية</li></Link>
<Link to="about-us" 
             offset={-50}  // Adjust for fixed headers
             smooth={true}
            ><li onClick={toggleVisibility}>من نحن</li></Link>
<Link to="service" 
            offset={-50}  // Adjust for fixed headers
            smooth={true}
            ><li onClick={toggleVisibility}>خدماتنا</li></Link>
<Link to="reviews" 
            offset={-50}  // Adjust for fixed headers
            smooth={true}
            ><li onClick={toggleVisibility}>الاراء والتقيمات</li></Link>
<Link to="footer" 
            offset={-50}  // Adjust for fixed headers
            smooth={true}
            ><li onClick={toggleVisibility}>تواصل معنا</li></Link>
</ul>
</div>
</div>
    </div>
    </>
}